import React from 'react';
import {
  useWindowSize,
} from 'vindi-ds-components';

import useToggle from '@hooks/feature_toggles';

import Header from './components/header';
import Tabs from './components/tabs';

function CustomerList() {
  const [description, setDescription] = React.useState('');
  const toggle = useToggle('new_ds_customers');
  const windowSize = useWindowSize();
  const { isMobile } = windowSize;

  if (!toggle) {
    return null;
  }

  return (
    <>
      <Header description={description} isMobile={isMobile} />

      <Tabs setDescription={setDescription} isMobile={isMobile} />
    </>
  );
}

export default CustomerList;
